
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"800","height":"800","viewBox":"0 0 800 800","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M573.209 268.504l6.092 2.619a19.923 19.923 0 007.891 1.631c7.75 0 15.127-4.533 18.383-12.104 4.363-10.147-.326-21.911-10.473-26.273l-6.092-2.62c-10.148-4.363-21.91.326-26.273 10.473-4.364 10.148.326 21.911 10.472 26.274z"}}),_c('path',{attrs:{"d":"M748.934 428.852V313.685c0-11.046-8.953-20-20-20H386.189c-11.046 0-20 8.954-20 20s8.954 20 20 20h245.586L386.189 439.268 94.083 313.685l292.106-125.583 131.116 56.369c10.148 4.362 21.91-.327 26.273-10.475 4.361-10.147-.328-21.911-10.475-26.273l-139.015-59.766a20.002 20.002 0 00-15.799 0L35.545 295.311a20.002 20.002 0 000 36.748L378.29 479.411a19.996 19.996 0 0015.798 0l188.64-81.101.004 138.395c-110.08 101.846-283.009 101.846-393.086-.001l.001-35.302c0-11.046-8.954-20.001-20-20.001-11.045 0-20 8.955-20 19.999l-.001 43.873a20.001 20.001 0 006.001 14.283c61.922 60.689 143.796 94.112 230.541 94.112 86.746 0 168.621-33.423 230.542-94.11a20.004 20.004 0 006.002-14.285l-.004-164.159 86.205-37.062v84.799c-16.293 7.572-27.623 24.086-27.623 43.204 0 19.62 14.643 71.239 47.623 71.239 32.979 0 47.621-51.619 47.621-71.239.001-19.117-11.327-35.63-27.62-43.203zm-20 69.035c-3.885-7.633-7.623-19.427-7.623-25.831 0-4.203 3.42-7.623 7.623-7.623s7.621 3.42 7.621 7.623c0 6.404-3.739 18.198-7.621 25.831z"}}),_c('path',{attrs:{"d":"M169.648 460.571c11.046 0 20-8.954 20-20v-6.655c0-11.046-8.954-20-20-20s-20 8.954-20 20v6.655c0 11.046 8.954 20 20 20z"}})])
          )
        }
      }
    